module.exports = __webpack_public_path__ + "static/img/12.35c696d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/12.jpg
// module id = xskw
// module chunks = 0